import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommUnitList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCUnit: DataSource;
    tableMCUnit: Table;
}
